module.exports = __webpack_public_path__ + "media/images/png/bg-danger-36f17eedf335bad50b08db9df07ae04a.png";